import { staticContentService } from '~/api/local-api/localService';
import { CustomSideModel } from '~/core/models/predefined-custom-side.model';

const customSidesApi = staticContentService.injectEndpoints({
  endpoints: (builder) => ({
    fetchCustomSides: builder.query<CustomSideModel[], void>({
      query: () => ({
        url: './public/assets/predefined-custom-sides.json',
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchCustomSidesQuery } = customSidesApi;
